import { useLayoutEffect, useRef, useState } from 'react';

// Measures the `.active` child matching `selector` inside the returned ref and
// reports its { left, width } so a sliding pill element can follow it.
// Re-measures when `dep` changes and on window resize.
// ponytail: offsetLeft/offsetWidth, no ResizeObserver — resize listener covers
// the only layout change that matters here (orientation / window resize).
export default function useSlidingPill(selector, dep) {
  const ref = useRef(null);
  const [box, setBox] = useState(null);
  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current?.querySelector(selector);
      if (el) setBox({ left: el.offsetLeft, width: el.offsetWidth });
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [selector, dep]);
  return [ref, box];
}
